/**
 * CLAUDE.md's low-data rule, read from the browser: on a metered / save-data
 * connection we suppress vector-tile fetches entirely and draw markers on a
 * plain canvas. Vector tiles are ~the whole cost of the map; the markers — the
 * thing the fleet manager actually needs — cost almost nothing and must keep
 * working. The real user is on a Mogadishu mobile network, so this is the
 * common path, not the exotic one.
 *
 * `navigator.connection` is non-standard and absent on iOS Safari, so its
 * absence is treated as "not low-data" (draw tiles) — the same default a
 * desktop gets. `saveData` (the user explicitly asked to save data) and the
 * slow effective types are both honoured.
 */

interface NetworkInformationLike {
  saveData?: boolean;
  effectiveType?: string;
}

export function detectLowData(): boolean {
  if (typeof navigator === 'undefined') return false;
  const conn = (navigator as unknown as { connection?: NetworkInformationLike }).connection;
  if (!conn) return false;
  if (conn.saveData === true) return true;
  return conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g';
}
